export default async function GetUnitsPerformanceApi(
  performanceCycle,
  page,
  positionId,
  LIMIT_PER_PAGE
) {
  let res = "";
  try {
    const body = {
      page: page,
      limit: LIMIT_PER_PAGE,
      performanceCycle: performanceCycle,
      positionId: positionId,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/units/units-performance`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
